export { default } from './VendorDetails';
